import { render, staticRenderFns } from "./AccessControlDetail.vue?vue&type=template&id=c937a49c&scoped=true"
import script from "./AccessControlDetail.vue?vue&type=script&lang=js"
export * from "./AccessControlDetail.vue?vue&type=script&lang=js"
import style0 from "./AccessControlDetail.vue?vue&type=style&index=0&id=c937a49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c937a49c",
  null
  
)

export default component.exports